import moment from 'moment'
import 'moment-timezone'

export function formatDate(date: number, tz?: string) {
  return moment(date)
    .tz(tz ?? 'UTC')
    .format('DD MMMM YYYY')
}
